import {
  INPUT_HEIGHT,
  ITEM_MARGIN,
} from '@/components_v2/ContextMenu/constants';
import { OptionData } from '@hooks/Filters/interfaces';

export const CHECK_ALL_KEY = 'all';
export const checkAllOption: OptionData = {
  id: CHECK_ALL_KEY,
  label: CHECK_ALL_KEY,
};
export const CONTAINER_HEIGHT = 320;
export const MAX_LIST_HEIGHT = CONTAINER_HEIGHT - INPUT_HEIGHT - ITEM_MARGIN;
export const MINIMUM_ITEMS_BREAKPOINT = 5;

// Paginated lists scroll internally (so react-window can report the visible
// range and trigger the next page), so their height has to be capped.
export const PAGINATED_LISTS_MAX_HEIGHT = 260;
export const PAGINATED_SELECTED_MAX_ITEMS = 2;
export const LOAD_MORE_THRESHOLD = 5;
